const GET_DB_AZURE = 'GET_DB_AZURE';
const GET_DB_AZURE_SUCCESS = 'GET_DB_AZURE_SUCCESS';
const GET_DB_AZURE_ERROR = 'GET_DB_AZURE_ERROR';
 
export {
  GET_DB_AZURE, GET_DB_AZURE_SUCCESS, GET_DB_AZURE_ERROR
  
};
